// Module
var code = `<div class="chartRactiveOuter" {{^.enabled}}disabled="" {{/}} {{#.useStyle}} style="outline:none; background:{{.backgroundColorBottom}};{{#.zIndex}}z-index:{{.zIndex}};{{/}}{{>visibility}}" {{/}}>

    <canvas id="{{.id}}"
            style="cursor:{{.currentCursor}};"
            on-mousedown="@this.onMouseDown(event)"
            on-mousemove="@this.onMouseMove(event)"
            on-mouseup="@this.onMouseUp(event)"
            on-wheel="@this.onMouseWheel(event)"
            on-mousewheel="@this.onMouseWheel(event)"
            on-mouseenter="@this.onMouseEnter(event)"
            on-mouseleave="@this.onMouseLeave(event)"
            on-dblclick="@this.onDoubleClick(event)"
            on-click="@this.onClick(event)">
    </canvas>
</div>`;
// Exports
export default code;